module.exports = {
      id: "longform-usage",
      viewBox: "0 0 12.6 15.258",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#longform",
      toString: function () {
        return this.url;
      }
    }